import { FILTER_LABEL_MAP, NON_FILTER_KEYS } from './charts/constants';

export const priorityMapping = {
  p4: 'Low',
  p3: 'Medium',
  p2: 'High',
  p1: 'Critical',
  nill: 'None',
  nopriority: 'None'
};

export const stripHtml = (html) => {
  if (!html) return '';
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

/**
 * Returns an array of human-readable label strings for every active filter
 * in the given reportQuery. Custom field keys are resolved via workspaceCustomFields.
 */
export const getActiveFilterLabels = (
  reportQuery = {},
  workspaceCustomFields = [],
) => {
  if (!reportQuery) return [];

  const labels = [];

  Object.entries(reportQuery).forEach(([key, value]) => {
    if (NON_FILTER_KEYS.has(key)) return;
    if (!value) return;

    // Handle customField[<id>] keys — resolve the field name from workspaceCustomFields
    const customFieldMatch = key.match(/^customField\[(.+)\]$/);
    if (customFieldMatch) {
      const fieldId = customFieldMatch[1];
      const field = workspaceCustomFields?.find((f) => f._id === fieldId);
      labels.push(field?.name ?? 'Custom field');
      return;
    }

    if (key in FILTER_LABEL_MAP) {
      labels.push(FILTER_LABEL_MAP[key]);
    }
  });

  return labels;
};
